import { COLORS } from '@consts/general';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    open: {
        position: 'sticky',
        top: 64,
        backgroundColor: 'white !important',
        zIndex: 99,
        borderBottom: `1px solid ${COLORS.BLUE}`,
        boxSizing: 'border-box',
    },
    selected: {
        backgroundColor: '#DDDDDD !important',
    },
    icon: {
        color: theme.palette.text.primary,
        fontSize: '28px',
    },
}));
